export const uboEnrollModule = {
  namespaced: true,
  state: {
    introData: {
      secondaryCustomerDetails: {
        firstName: '',
        lastName: '',
        onboardingStatus: '',
        passwordSet: false,
        country: '',
      },
      primaryCustomerDetails: {
        firstName: '',
        lastName: '',
        onboardingStatus: '',
        passwordSet: false,
        country: '',
      },
      businessDetails: {
        name: '',
        type: '',
      },
    },
    uboId: '',
    mfaData: {},
    validationData: {},
    accessToken: '',
    completeData: {},
  },
  mutations: {
    updateIntroData(state, payload) {
      state.introData = { ...state.introData, ...payload }
    },
    updateMfaData(state, payload) {
      state.mfaData = { ...state.mfaData, ...payload }
    },
    updateValidationData(state, payload) {
      state.validationData = { ...state.validationData, ...payload }
    },
    updateAccessToken(state, payload) {
      state.accessToken = payload
    },
    updateCompleteData(state, payload) {
      state.completeData = { ...state.completeData, ...payload }
    },
    setCustomerId(state, payload) {
      state.uboId = payload
    },
  },
  actions: {
    setIntroData({ commit }, payload) {
      commit('updateIntroData', payload)
    },
    setMfaData({ commit }, payload) {
      commit('updateMfaData', payload)
    },
    setValidationData({ commit }, payload) {
      commit('updateValidationData', payload)
    },
    setAccessTokenData({ commit }, payload) {
      commit('updateAccessToken', payload)
    },
    setCompleteData({ commit }, payload) {
      commit('updateCompleteData', payload)
    },
  },
  getters: {
    uboEnrollmentData(state) {
      return state
    },
  },
}



// WEBPACK FOOTER //
// ./src/RF_store/modules/uboEnroll.module.js